import {
    Alert,
    Avatar,
    Button,
    Checkbox,
    FormControl,
    Grid,
    IconButton,
    InputAdornment,
    OutlinedInput,
    Paper,
    TextField,
    Tooltip,
    Typography
} from "@mui/material"
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import styles from './company.module.css';
import MaterialFileUpload from "../../components/MaterialFileUpload/component";
import { AVATAR_TYPES } from "../../utilities/constants";
import { Box } from "@mui/system";
import { useEffect, useState } from "react";
import { validateDoc, validateEmail, validatePassword } from "../../utilities/general";
import { useDispatch } from "react-redux";
import { useCompanySelector } from "./reducers/store";
import { selectCompany, selectError, selectLoading } from "./reducers/reducer";
import { createCompany, limpiarCompany } from "./reducers/actions";
import Loading from "../../components/Loading/component";
import MaterialConfirmUser from "../../components/MaterialConfirmUser/component";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

function CompanyComponent() {

    const headerStyle = { margin: 0 }
    const avatarStyle = { backgroundColor: '#1bbd7e', marginBottom: 10 }
    const labelFont = { fontSize: '0.6rem' }

    const [showPassword, setShowPassword] = useState(false);

    const [tipoDoc, setTipoDoc] = useState('NIT');
    const [numDoc, setNumDoc] = useState('');
    const [emptyNumDoc, setEmptyNumDoc] = useState(false);
    const [messageNumDoc, setMessageNumDoc] = useState(false);
    const [razonSocial, setRazonSocial] = useState('');
    const [emptyRazonSocial, setEmptyRazonSocial] = useState(false);
    const [messageRazonSoial, setMessageRazonSocial] = useState(false);
    const [razonSocialPopUp, setRazonSocialPopUp] = useState('');
    const [correo, setCorreo] = useState('');
    const [correoPopUp, setCorreoPopUp] = useState('');
    const [emptyMail, setEmptyMail] = useState(false);
    const [messageMail, setMessageMail] = useState(false);
    const [messageMailValidate, setMessageMailValidate] = useState(false);
    const [password, setPassword] = useState('');
    const [confPassword, setConfPassword] = useState('');
    const [condiciones, setCondiciones] = useState(false);
    const [invalidPass, setInvalidPass] = useState(false);
    const [correoInvalido, setCorreoInvalido] = useState(false);
    const [invalidate, setInvalidate] = useState(true);
    const [severity, setSeverity] = useState('info');
    const [message, setMessage] = useState(false);
    const [messagePassword, setMessagePassword] = useState(false);
    const [open, setOpen] = useState(false);
    const [imageFile, setImageFile] = useState(false);
    const [emptyCondiciones, setEmptyCondiciones] = useState(false);
    const [messageCondiciones, setMessageCondiciones] = useState(false);



    const handleClose = () => {
        dispatch(limpiarCompany())
        setOpen(false);
    };

    const dispatch = useDispatch();
    const loading = useCompanySelector(selectLoading);
    const company = useCompanySelector(selectCompany);
    const error = useCompanySelector(selectError);

    const onAvatarHandler = (file) => {
        setImageFile(file)
        // console.log("imageFile person", imageFile)
    }

    const onLimpiarFormularioHandler = () => {
        setTipoDoc('NIT')
        setNumDoc('')
        setRazonSocial('')
        setCorreo('')
        setPassword('')
        setConfPassword('')
        setCondiciones(false)
        setMessage(false)
        setImageFile(false)
    }

    const handleTogglePasswordVisibility = () => {
        //console.log("ASDASDASDASDASDASDSADa")
        setShowPassword(!showPassword);
        console.log(showPassword)
    };


    const onNumDocHandler = (event) => {
        setNumDoc(event.target.value)
        if (event.target.value === '') {
            setSeverity('error');
            setMessageNumDoc('El número de documento es obligatorio.');
            setEmptyNumDoc(true)
        } else {
            setMessageNumDoc(false)
            setEmptyNumDoc(false)
        }
    }
    const onRazonSocialHandler = (event) => {
        setRazonSocial(event.target.value)
        setRazonSocialPopUp(event.target.value)
        if (event.target.value === '') {
            setSeverity('error');
            setMessageRazonSocial('El número de documento es obligatorio.');
            setEmptyRazonSocial(true)
        } else {
            setMessageRazonSocial(false)
            setEmptyRazonSocial(false)
        }
    }
    const onCorreoHandler = (event) => {
        setCorreo(event.target.value)
        setCorreoPopUp(event.target.value)
        if (event.target.value === '') {
            setSeverity('error');
            setMessageMail('Ingresa tu correo electrónico, por favor.')
            setEmptyMail(true)
        } else {
            setMessageMail(false)
            setEmptyMail(false)
        }
    }
    const onPasswordHandler = (event) => {
        setPassword(event.target.value)
        if (event.target.value === '') {
            setSeverity('error');
            setMessage('La contraseña es obligatoria.');
            setInvalidPass(true)
        } else {
            setMessage(false)
            setInvalidPass(false)
        }
    }
    const onConfPasswordHandler = (event) => {
        setConfPassword(event.target.value)
        if (event.target.value === '') {
            setSeverity('error');
            setMessage('La contraseña es obligatoria.');
            setInvalidPass(true)
        } else {
            setMessage(false)
            setInvalidPass(false)
        }
    }
    const onCondicionesHandler = (event) => {
        setCondiciones(event.target.checked)
        if (event.target.checked === false) {
            setSeverity('error');
            setMessageCondiciones('Acepte terminos y condiciones de uso.');
            setEmptyCondiciones(true)
        } else {
            setMessageCondiciones(false)
            setEmptyCondiciones(false)
        }
    }

    const onFormHandler = (event) => {
        event.preventDefault();
        const companyUser = {
            tipoDoc, numDoc, razonSocial, correo, password
        }
        setMessage(false);
        setInvalidPass(false);
        setCorreoInvalido(false);
        setMessageNumDoc(false);
        setMessageMail(false);
        setEmptyNumDoc(false);
        setEmptyRazonSocial(false);
        setMessageRazonSocial(false);
        setMessagePassword(false);
        setEmptyMail(false);

        if (!numDoc || !razonSocial || !correo || !password || !condiciones || !confPassword) {
            setMessage('Por favor diligencia todos los campos. ')
            if (!numDoc) {
                setSeverity('error');
                setMessageNumDoc('El número de documento es obligatorio.');
                setEmptyNumDoc(true)
            }

            if (numDoc && numDoc.length < 10) {
                setSeverity('error');
                setMessageNumDoc('El número de documento debe tener mas de 10 caracteres.');
                setEmptyNumDoc(true)
            }
            if (numDoc && numDoc.length > 20) {
                setSeverity('error');
                setMessageNumDoc('El número de documento debe tener menos de 20 caracteres.');
                setEmptyNumDoc(true)
            }

            if (!razonSocial) {
                setSeverity('error');
                setMessageRazonSocial('El nombre de la razón social es obligatorio.');
                setEmptyRazonSocial(true)
            }
            if (!correo) {
                setSeverity('error');
                setMessageMail('Ingresa tu correo electrónico, por favor.');
                setEmptyMail(true)
            }
            if (!password && !confPassword) {
                setSeverity('error');
                setMessagePassword('La contraseña es obligatoria.');
                setInvalidPass(true)
            }
            
            if (!password && confPassword) {
                setSeverity('error');
                setMessagePassword('La contraseña es obligatoria.');
                setInvalidPass(true)
            }

            if (password && !confPassword) {
                setSeverity('error');
                setMessagePassword('Por favor confirma tu contraseña.');
                setInvalidPass(true)
            }

            if (password && confPassword && password !== confPassword) {
                setSeverity('error');
                setMessagePassword('Las contraseñas deben ser iguales.');
                setInvalidPass(true)
            }

            if (condiciones === false) {
                setSeverity('error');
                setMessageCondiciones('Acepte terminos y condiciones de uso.');
            }
            return
        }

        let isValidate = true;
        if (password !== confPassword) {
            setSeverity('error');
            setMessagePassword('Las contraseñas deben ser iguales.');
            setInvalidPass(true)
            isValidate = false

        }
        if (!validatePassword(password)) {
            setSeverity('error');
            setMessagePassword('Ingrese una contraseña valida.');
            setInvalidPass(true)
            isValidate = false

        }

        if (!validateDoc(numDoc)) {
            setSeverity('error');
            setMessageNumDoc('Ingrese un número de documento valido.');
            setEmptyNumDoc(true)
            isValidate = false
        }

        if (!validateEmail(correo)) {
            setSeverity('error');
            setMessageMailValidate('Ingrese un correo valido.');
            setCorreoInvalido(true)
            isValidate = false
        }

        if (razonSocial.length > 100) {
            setSeverity('error');
            setMessageRazonSocial('El nombre de la razón social es obligatorio.');
            setEmptyRazonSocial(true)
            isValidate = false
        }

        console.log("AASDASD2", isValidate)
        if (!isValidate) {
            return
        }


        dispatch(createCompany({ companyUser, imageFile }));
        return

    }

    useEffect(() => {
        //Comapañia creada exitosamente
        if (company) {
            onLimpiarFormularioHandler();
            setOpen(true);
        }
    }, [company, open, dispatch]);

    return (

        <div className={`${styles.contenedor}`}>

        
        <Grid className={`${styles.grid}`}>
            <Loading show={loading} text={'Apreciado usuario, estamos validando la información ingresada por favor espere un momento...'} />
            <Paper elevation={20} className={`${styles.paper}`}>
                <MaterialConfirmUser
                    title={`¡Felicitaciones, ${razonSocialPopUp}!`}
                    cuerpo={`Tu cuenta está casi lista. Falta un último paso y es el mas fácil, ingresa al correo ${correoPopUp} y confirma tu cuenta.`}
                    open={open}
                    cuenta={company.cuenta}
                    onClose={handleClose}
                    company={company.cuenta}
                />
                {message && <Alert severity={severity}>{message}</Alert>}
                {company && <Alert severity={'info'}>
                    {company.message}
                </Alert>
                }
                {error && <Alert severity={'error'}>{error.message}</Alert>}
                <form onSubmit={onFormHandler}>
                    <Grid align='center'>
                        <Avatar style={avatarStyle}>
                            <AddCircleOutlineIcon />
                        </Avatar>
                        <h2 style={headerStyle}>Compañia</h2>
                        <Typography variant='caption'
                            gutterBottom>¡Por favor llene el formulario para crear su cuenta!
                        </Typography>
                    </Grid>
                    <div className={`${styles.campos}`}>
                        * Campos obligatorios.

                    </div>

                    <Box m={1}>
                        <TextField fullWidth disabled InputProps={{ readOnly: true, }} value={tipoDoc} placeholder="NIT" />
                    </Box>
                    <Box m={1}>
                        <Tooltip title="ingrese el numero del NIT 
                                        sin puntos, especios ni guiones, incluyendo el digito
                                        verificación" placement="top">
                            <TextField
                                //className={`${emptyNumDoc ? styles.error : ''}`}
                                onChange={onNumDocHandler}
                                value={numDoc}
                                error={emptyNumDoc}
                                type="number"
                                fullWidth
                                label='Número de identificacion tributaria *'
                                placeholder="Número de identificacion tributaria" />
                        </Tooltip>
                        <p className={`${styles.errorText}`} >
                            {emptyNumDoc ? messageNumDoc : ''}
                        </p>
                    </Box>
                    <Box m={1}>
                        <TextField
                            //className={`${emptyRazonSocial ? styles.error : ''}`}
                            onChange={onRazonSocialHandler}
                            value={razonSocial}
                            error={emptyRazonSocial}
                            fullWidth
                            label='Razón social *'
                            placeholder="Razón social" />

                        <p className={`${styles.errorText}`} >
                            {emptyRazonSocial ? messageRazonSoial : ''}
                        </p>
                    </Box>
                    <Box m={1}>
                        <TextField
                            //className={`${correoInvalido ? styles.error : ''} || ${emptyMail ? styles.error : ''}`}
                            fullWidth
                            error={correoInvalido || emptyMail}
                            label='Correo *'
                            placeholder="Ingrese su correo electronico"
                            onChange={onCorreoHandler}
                            value={correo}
                        />

                        <p className={`${styles.errorText}`} >
                            {emptyMail ? messageMail : ''}
                        </p>

                        <p className={`${styles.errorText}`} >
                            {correoInvalido ? messageMailValidate : ''}
                        </p>
                        {/*<TextField onChange={onCorreoHandler} fullWidth label='Correo *' placeholder="Ingrese su correo electronico" />*/}
                    </Box>
                    <Box m={1}>
                        <Tooltip title={
                            <div>
                                <p>
                                    La contraseña debe tener:
                                </p>
                                <ul>
                                    <li>Mínimo 8 caracteres.</li>
                                    <li>Máximo 15.</li>
                                    <li>Al menos una letra mayúscula.</li>
                                    <li>Al menos una letra minúcula.</li>
                                    <li>Al menos un dígito.</li>
                                    <li>No espacios en blanco.</li>
                                    <li>Al menos 1 caracter especial.</li>
                                </ul>
                            </div>
                        } placement="top">
                            <TextField
                                //className={`${invalidPass ? styles.error : ''}`}
                                id="standard-Password-input"
                                onChange={onPasswordHandler}
                                error={invalidPass}
                                fullWidth
                                value={password}
                                label="Contraseña *"
                                autoComplete="current-password"
                                type={showPassword ? 'text' : 'password'}
                                placeholder="Contraseña"
                                InputProps={{
                                    endAdornment: (
                                        <span className=" ">
                                            <IconButton onClick={handleTogglePasswordVisibility} end="edge">
                                                {showPassword ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>

                                        </span>
                                    ),
                                }}
                            />
                        </Tooltip>
                    </Box>

                    <Box m={1}>
                        <TextField
                            //className={`${invalidPass ? styles.error : ''}`}
                            id="standard-confPassword-input"
                            onChange={onConfPasswordHandler}
                            error={invalidPass}
                            fullWidth
                            value={confPassword}
                            label="Confirme su contraseña *"
                            autoComplete="current-password"
                            type={showPassword ? 'text' : 'password'}
                            placeholder="Confirme su contraseña"
                            InputProps={{
                                endAdornment: (
                                    <span className=" ">
                                        <IconButton onClick={handleTogglePasswordVisibility} end="edge">
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>

                                    </span>
                                ),
                            }}
                        />
                        <p className={`${styles.errorText}`} >
                            {invalidPass ? messagePassword : ''}
                        </p>
                    </Box>
                    <Grid style={{ margin: "10px 0" }}>
                        <MaterialFileUpload
                            label={'Seleccione un archivo...'}
                            uploadLabel={'Subir'}
                            onUpload={imageFile ? onAvatarHandler : onAvatarHandler}
                            value={imageFile}
                            types={AVATAR_TYPES}
                            placeholder={'¡Puedes subir una imagen para tu logo!'}
                            fileName={imageFile?.name}
                        />

                        {/*<FileUpload chooseLabel="Añadir" mode="basic" name="demo[]" url="/api/upload" accept="image/*" maxFileSize={1000000} />*/}
                    </Grid>

                    <p className={`${styles.labelFont}`}>
                        {<Checkbox onChange={onCondicionesHandler}
                            checked={condiciones}
                            inputProps={{ 'aria-label': 'controlled' }}
                        />}
                        * He leído y acepto<a href=" " target="_blank"> los términos y condiciones de uso de Avanti-It.</a>

                    </p>
                    {messageCondiciones && <Alert severity={severity}>{messageCondiciones}</Alert>}
                    <Typography align='center'>
                        <Button
                            color='primary'
                            size='large'
                            type='submit'
                            variant='contained'
                        >
                            Crear cuenta
                        </Button>
                    </Typography>
                </form>
            </Paper>
        </Grid>
        </div>
    );
}

export default CompanyComponent;